/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchnellauswahlDto } from '../../models/schnellauswahl-dto';
import { UpdateSchnellauswahlDto } from '../../models/update-schnellauswahl-dto';

export interface UpdateSchnellauswahl$Plain$Params {

/**
 * ID der Schnellauswahl die bearbeitet werden soll
 */
  schnellauswahlId: string;
  
    /**
     * Daten der zu bearbeitenden Schnellauswahl
     */
    body?: UpdateSchnellauswahlDto
}

export function updateSchnellauswahl$Plain(http: HttpClient, rootUrl: string, params: UpdateSchnellauswahl$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SchnellauswahlDto>> {
  const rb = new RequestBuilder(rootUrl, updateSchnellauswahl$Plain.PATH, 'put');
  if (params) {
    rb.path('schnellauswahlId', params.schnellauswahlId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchnellauswahlDto>;
    })
  );
}

updateSchnellauswahl$Plain.PATH = '/v1/schnellauswahl/{schnellauswahlId}';
